// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"5fd48b8d","880":"8e54ad94"}[chunkId] + ".chunk.js";
};